// extracted by mini-css-extract-plugin
module.exports = {"section":"LoginPage_section__TPorQ","container":"LoginPage_container__pQCfz","load":"LoginPage_load__8NhUU"};